// A short reference customers and staff can quote for a booking, e.g.
// "#6D3A602C". Bookings have no sequential number, so this is the first 8
// characters of the booking's id: stable and practically unique per company.
export const bookingReference = (id) => (id ? `#${String(id).replace(/-/g, '').slice(0, 8).toUpperCase()}` : null);
